/**
 * Filter out inactive users AND bot accounts
 */
export const CPUS_SEARCH_QUERY_FILTER =
	'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:"app")';
